import {
  AssociationQuery,
  AssociationState,
  mutationSchemas
} from 'v4/entities/associations/resource__shortlist/resource__shortlist.schemas';
import { defineEntityEffect } from 'v4/entities/common/defineEntityEffect';
import { UseResourceShortlistAssociationEffectsApi } from './http/resource__shortlist.http.effects';

export const createUpvoteEffect = (
  useApi: UseResourceShortlistAssociationEffectsApi
) =>
  defineEntityEffect({
    type: 'upvote',
    requestSchema: mutationSchemas.upvote.request,
    responseSchema: mutationSchemas.upvote.response,
    useQueryFn: () => useApi().upvote
  })
    .withOptimisticReconciler<AssociationState, AssociationQuery>(
      config => (state, request, query) => {
        // todo add optimistic voting, should insert action with proper user/guest
        return state;
      }
    )
    .withResponseReconciler(config => (state, request, response, query) => {
      return {
        state: {
          ...state,
          results: state.results.map(item =>
            item.id === request.association_id ? { ...item, ...response } : item
          )
        },
        shouldInvalidate: false
      };
    })
    .build();
